
import { useMutation, useQuery } from "react-query"
import { useToast } from "../../../hook/usetoast";
import DataService from '../../../config/DataServices'
import { queryClient } from "../../../config";
import StakeService from "../../../config/StakeServices";

const { postRequest, getRequest } = DataService()
const { getStakeRequest } = StakeService()



export const useGetBuyVRS = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/fgkjnkj", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
        }
    })
}


export const useGetPillPrice = () => {

    return useQuery({
        queryKey: ["pill-price"],
        queryFn: () => {
            return getRequest(`user/auth/getPillPrice`)
        },
        enabled: !!sessionStorage.getItem('user_JWT'),
    })
}

export const useGetCurrentPillPrice = () => {

    return useQuery({
        queryKey: ["current-price"],
        queryFn: () => {
            return getRequest(`user/auth/currentprice`)
        },
        enabled: !!sessionStorage.getItem('user_JWT'),
    })
}
export const useBuyToken = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/ico/buyToken", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            return toast.success(success?.message)
        }
    })
}


export const useCheckMinMax = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/ico/checkMinAndMax", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
        }
    })
}


export const useICOStatus = () => {

    return useQuery({
        queryKey: ["ico-status"],
        queryFn: () => {
            return getRequest(`user/auth/site-settings`)
        },
    })
}


export const useGetTopUpVRS = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/topvg", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
        }
    })
}


export const useLevelTopUp = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/adminPay", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            queryClient.refetchQueries("get-profile")
            return toast.success(success?.message)

        }
    })
}



export const useGetWithdrawVRS = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/withdrawvrs", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
        }
    })
}


export const useUserWithdraw = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/withdrawStore", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            queryClient.refetchQueries("get-profile")  
            queryClient.refetchQueries("get-balance")  
            return toast.success(success?.message)
        }

    })
}


export const useWithdrawMinMax = () => {

    return useQuery({
        queryKey: ["withdraw-minmax"],
        queryFn: () => {
            return getRequest(`user/auth/getminmax`)
        },
    })
}



export const useUserSlotHis = ({page,size,searchText,slotNumber}) => {
    return useQuery({
        queryKey: ["user-slot",page,size,searchText,slotNumber],
        queryFn: () => {
            return getStakeRequest(`user/stake/getSlotHistory?page=${page}&size=${size}&search=${searchText}&slotType=${slotNumber}`)
        },
    })
}


export const useUserRewardView = ({page,size,slotId}) => {
    return useQuery({
        queryKey: ["reward-view",page,size,slotId],
        queryFn: () => {
            return getRequest(`user/ico/getSlotRewardHis?page=${page}&size=${size}&slotId=${slotId}`)
        },
    })
}




export const useUserClaimSlot = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/ico/claimAirdropSlot", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            queryClient.refetchQueries("reward-view")  
            queryClient.refetchQueries("airdrop-slotreward")  
            return toast.success(success?.message)
        }

    })
}


export const useUserRedeemWalletReward = ({page,size,slotId}) => {
    return useQuery({
        queryKey: ["slot-redeemReward",page,size,slotId],
        queryFn: () => {
            return getStakeRequest(`user/redeem/getSlotRewardHis?page=${page}&size=${size}&slotId=${slotId}`)
        },
    })
}